import './App.css';
import { Route, Routes, useLocation } from 'react-router-dom';
import HomePage from './Components/HomePage/HomePage';
import AdminLogin from './Components/AdminLogin/AdminLogin';
import AdminDashboard from './Components/AdminDashboard/AdminDashboard';
// import UnderMaintenance from './Components/UnderMaintenance/undermaintenance';
import { AnimatePresence } from "framer-motion";
import ScrollToTop from "./Components/ScrollToTop";

function App() {
   const location = useLocation();
  return ( 
    <>
     <ScrollToTop />
       <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
          <Route path="/" element={<HomePage/>} />
          <Route path="admin_login" element={<AdminLogin/>} />
          <Route path="about-us" element={<HomePage/>} />
          <Route path="adminDashboard" element={<AdminDashboard/>} />
        </Routes> 
          </AnimatePresence>
</>
  );
}

export default App;